import React from 'react';
import MarketplaceContainer from '../../components/configure/Marketpalace';

const Marketplace = () => {
  return <MarketplaceContainer />;
};

export default Marketplace;
